import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tiefbau'
})
export class TiefbauPipe implements PipeTransform {
  transform(value: 'YES' | 'NO' | 'PUBLIC_ONLY' | string): string {
    switch (value) {
      case 'YES':
        return 'Mit allen Tiefbauarbeiten';
      case 'NO':
        return 'Ohne Tiefbauarbeiten';
      case 'PUBLIC_ONLY':
        return 'Ohne Tiefbauarbeiten im privaten Bereich';
    }
    return value;
  }
}
